'use strict';

var React = require('react');
var PropTypes = require('prop-types');
var Button = require('./Button.js');
var FontIcon = require('./FontIcon.js');
var Typography = require('./Typography-d8cec00c.js');
var react = require('@linaria/react');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var _exp = function _exp() {
  return function (_ref) {
    var active = _ref.active;
    return active ? '1' : '0';
  };
};
var _exp2 = function _exp2() {
  return function (_ref2) {
    var active = _ref2.active;
    return active ? 'scale(1)' : 'scale(0.9)';
  };
};
var _exp3 = function _exp3() {
  return function (_ref3) {
    var active = _ref3.active;
    return active ? 'var(--layout-z-modal)' : '-1';
  };
};
var _exp5 = function _exp5() {
  return function (_ref4) {
    var active = _ref4.active;
    return active ? 'block' : 'none';
  };
};
var StyledModal = /*#__PURE__*/react.styled('div')({
  name: "StyledModal",
  "class": "souoawy",
  propsAsIs: false,
  vars: {
    "souoawy-0": [_exp()],
    "souoawy-1": [_exp2()],
    "souoawy-2": [_exp3()],
    "souoawy-3": [_exp5()]
  }
});

var propTypes = {
  /** Controls whether or not the modal is open and visible */
  isOpen: PropTypes__default["default"].bool.isRequired,
  /** Function that is called when the modal is toggled */
  toggleModal: PropTypes__default["default"].func.isRequired,
  /** Controls whether to show the x button on the modal */
  clickOffToClose: PropTypes__default["default"].bool.isRequired,
  /** The top header text of the modal */
  title: PropTypes__default["default"].string.isRequired,
  /** Controls whether to disable the background scroll */
  disableBackgroundScroll: PropTypes__default["default"].bool,
  /** Additional classes to add to the modal component */
  className: PropTypes__default["default"].string,
  /** Call to action buttons at the bottom of the modal ex: Cancel, Submit */
  buttons: PropTypes__default["default"].arrayOf(PropTypes__default["default"].shape({
    buttonText: PropTypes__default["default"].string.isRequired,
    buttonStyle: PropTypes__default["default"].string.isRequired,
    callbackFunc: PropTypes__default["default"].func.isRequired,
    isLoading: PropTypes__default["default"].bool.isRequired
  }).isRequired),
  id: PropTypes__default["default"].string
};
var Modal = function Modal(_ref) {
  var isOpen = _ref.isOpen,
    toggleModal = _ref.toggleModal,
    clickOffToClose = _ref.clickOffToClose,
    title = _ref.title,
    children = _ref.children,
    className = _ref.className,
    buttons = _ref.buttons,
    _ref$disableBackgroun = _ref.disableBackgroundScroll,
    disableBackgroundScroll = _ref$disableBackgroun === void 0 ? false : _ref$disableBackgroun,
    id = _ref.id;
  var ctaButtons = buttons === null || buttons === void 0 ? void 0 : buttons.reduce(function (array, item, index) {
    var buttonText = item.buttonText,
      buttonStyle = item.buttonStyle,
      callbackFunc = item.callbackFunc,
      isLoading = item.isLoading;
    array.push( /*#__PURE__*/jsxRuntime.jsx(Button["default"], {
      buttonStyle: buttonStyle,
      onClick: callbackFunc,
      loading: isLoading,
      role: "navigation",
      children: buttonText
    }, index));
    return array;
  }, []);
  React.useEffect(function () {
    if (disableBackgroundScroll) {
      document.body.style.overflow = isOpen ? 'hidden' : 'unset';
    }
    return function () {
      if (disableBackgroundScroll) {
        document.body.style.overflow = 'unset';
      }
    };
  }, [isOpen]);
  return /*#__PURE__*/jsxRuntime.jsxs(StyledModal, {
    active: isOpen,
    "aria-modal": true,
    "aria-hidden": !isOpen,
    "aria-labelledby": "modal-title",
    "aria-describedby": "modal-description",
    role: "dialog",
    className: "modal ".concat(className || ''),
    id: id || '',
    children: [/*#__PURE__*/jsxRuntime.jsxs("div", {
      className: "modal-content",
      children: [clickOffToClose && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "modal-close",
        onClick: toggleModal,
        role: "navigation",
        "data-dismiss": "modal",
        "aria-label": "Close modal",
        children: /*#__PURE__*/jsxRuntime.jsx(FontIcon["default"], {
          iconName: "close",
          fontSize: "var(--font-size-s)"
        })
      }), !!title && /*#__PURE__*/jsxRuntime.jsx(Typography.Typography, {
        variant: "h2",
        id: "modal-title",
        className: "modal-title",
        children: title
      }), /*#__PURE__*/jsxRuntime.jsx("div", {
        id: "modal-description",
        children: children
      }), ctaButtons && /*#__PURE__*/jsxRuntime.jsx("div", {
        className: "modal-buttons",
        children: ctaButtons
      })]
    }), /*#__PURE__*/jsxRuntime.jsx("div", {
      className: "modal-backdrop",
      onClick: clickOffToClose ? toggleModal : undefined,
      role: "navigation"
    })]
  });
};
Modal.propTypes = propTypes;

exports.Modal = Modal;
exports.StyledModal = StyledModal;
